import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { Work } from "@mui/icons-material";
import meetJeremiah  from "../images/about_deb_bg.jpg";

const SupportingOurWorkersAndBusinesses = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetJeremiah })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <Work sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Supporting Our Workers and Businesses
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Jeremiah will support our public employees and
              small businesses to protect our county from the destructive
              actions of the current president. We are facing uncertain economic
              times with the contraction of the Federal workforce and tax
              increases at the State level. Our long-term economic health is
              dependent upon retaining and assisting the highly skilled
              workforce that is being impacted by Federal layoffs. Deb’s
              legislative record has consistently promoted strategies to grow
              high-quality jobs, spend our County revenues responsibly, and
              protect our high quality of life.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Supported legislation to prioritize hiring of terminated Federal workers for County jobs." />
              <Bullet text="Voted against tax and fee increases that would make the County more expensive to live in and undermine the commercial tax base." />
              <Bullet text="Advocated against excessive spending on Capital projects that would put more of a burden on taxpayers." />
              <Bullet text="Promoted economic development efforts that assist terminated Federal employees to start their own businesses or pursue private sector jobs." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default SupportingOurWorkersAndBusinesses;
